module.exports = __webpack_public_path__ + "static/media/netcore.a79b1a75.jpeg";